import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAuthenticationCredentialEditCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/authentication_credentials",
];
